import * as React from "react";
import { Button } from "./Button";

export class EditButton extends Button {

	render() {
		return <Button {...this.props}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style={{fill: '#464646'}}>
					<path d="M6.08,21.7l8.65,4.61L6.3,30ZM14,7.09l8.89,5.1L16.08,24.09l-0.51-1.52L13,22.3l-0.45-1.63L10,20.57,9.25,18.78,7.19,19Zm4.27-5.63a1.33,1.33,0,0,1,.7.17l6.3,3.62a1.84,1.84,0,0,1,.39,2.54L24.93,9.09,15.86,3.89l0.75-1.31A2.1,2.1,0,0,1,18.29,1.46Z" />
				</svg>
			</i>
		</Button>;
	}
}
